import React,{useEffect,useState} from 'react'
import { data } from '../Data'
import logo from '../logo.png';
import {Link} from 'react-router-dom'
import './Catalog.css'
const ProgramsByCategory = () => {
  

  const [isFiltered,setIsFiltered]=useState(false);
  const [filtered,setFiltered]=useState([]);
  const [classes,setClasses]=useState([]);
  const [categories,setCategories]=useState([]);
  const [selectedCategory,setCategory]=useState('def');
  const [selectedGrade,setGrade]=useState('def');
  const [selectedDate,setDate]=useState('def');

  const sortByDate=function(a, b) { return new Date(a.Start_Date). getTime() - new Date(b.Start_Date).getTime()}
  const sortByGrade=function(a, b) {return (a.Grades)<(b.Grades)}
 
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  useEffect(() => {

    setCategories(data.filter(c=>c.Program_Category!='Internship').map(c=>c.Program_Category).sort().filter(onlyUnique));
    setClasses(data);
  }, [])
  return (
    <div className="container">
<Link to='/'> <button className='btn btn-dark btn-sm p-3 btn-block'> Back to Homepage</button></Link>
      <div className='row mt-5 mb-3'>
      <div className='col col-lg-2 empty-space'>
                    {/* <Link to='/'>
                        <img style={{ width: '15rem' }} src={logo} alt='osp logo' />
                    </Link> */}
                </div>


        <div className='container' style={{ textAlign: 'right' }}><h3>Please use filters to view classes by<br/>
        Program Cateogry OR Student's Grade OR Program Start Date<br/><br/></h3> 
        </div>
        <div className='container' style={{ textAlign: 'right' }}><h3 style={{display:'inline',marginRight:'1rem'}}>Program Category:</h3>
  
          <select
            style={{
              display:'inline',
              width: '200px',
              height: '30px',
              marginBottom: '1rem' }}
            defaultValue='def'
            
            value={selectedCategory}
            onChange={(e) => {
            
                setDate('def')
                setGrade('def');
                setIsFiltered(true);
                setCategory(e.target.value);
                    setFiltered(classes.filter(c=>c.Program_Category==e.target.value).sort(sortByDate));
              
              console.log(e.target.value)
            }}
          >
            <option value='def' disabled>
              ---Please select one---
            </option>
            {categories.map((c,i)=>
            
            <option value={c} key={i}>{c}</option>
            )}
             <br/>
           <br/>
          </select>
          
          <div  style={{ textAlign: 'right' }}><h3 style={{display:'inline',marginRight:'1rem'}}>Student's Grade in Fall 2021:</h3>
  
  <select
    style={{
      display:'inline',
      width: '200px',
      height: '30px',
      marginBottom: '1rem' }}
    defaultValue='def'

    value={selectedGrade}
    onChange={(e) => {
    
      setDate('def')
      setCategory('def');
        setIsFiltered(true);

        switch(parseInt(e.target.value)){

          case 0:
            {setGrade('0');setFiltered(classes.filter(c=>c.Grade_00=='TRUE').sort(sortByDate));break};
            case 1:
            {setGrade('1');setFiltered(classes.filter(c=>c.Grade_01=='TRUE').sort(sortByDate));break;}
            case 2:
            {setGrade('2');setFiltered(classes.filter(c=>c.Grade_02=='TRUE').sort(sortByDate));break;}
            case 3:
            {setGrade('3');setFiltered(classes.filter(c=>c.Grade_03=='TRUE').sort(sortByDate));break;}
            case 4:
            {setGrade('4');setFiltered(classes.filter(c=>c.Grade_04=='TRUE').sort(sortByDate));break;}
            case 5:
            {setGrade('5');setFiltered(classes.filter(c=>c.Grade_05=='TRUE').sort(sortByDate));break;}
            case 6:
            {setGrade('6');setFiltered(classes.filter(c=>c.Grade_06=='TRUE').sort(sortByDate));break;}
            case 7:
            {setGrade('7');setFiltered(classes.filter(c=>c.Grade_07=='TRUE').sort(sortByDate));break;}
            case 8:
            {setGrade('8');setFiltered(classes.filter(c=>c.Grade_08=='TRUE').sort(sortByDate));break;}
            case 9:
            {setGrade('9');setFiltered(classes.filter(c=>c.Grade_09=='TRUE').sort(sortByDate));break;}
            case 10:
            {setGrade('10');setFiltered(classes.filter(c=>c.Grade_10=='TRUE').sort(sortByDate));break;}
            case 11:
            {setGrade('11');setFiltered(classes.filter(c=>c.Grade_11=='TRUE').sort(sortByDate));break;}
            default:
            {setGrade('12');setFiltered(classes.filter(c=>c.Grade_12=='TRUE').sort(sortByDate));break;}
        }
      
      console.log(e.target.value)
    }}
  >
    <option value='def' disabled>
      ---Please select one---
    </option>
    <option value='1'>First Grade</option>
    <option value='2'>Second Grade</option>
    <option value='3'>Third Grade</option>
    <option value='4'>Fourth Grade</option>
    <option value='5'>Fifth Grade</option>
    <option value='6'>Sixth Grade</option>
    <option value='7'>Seventh Grade</option>
    <option value='8'>Eighth Grade</option>
    <option value='9'>Ninth Grade</option>
    <option value='10'>Tenth Grade</option>
    <option value='11'>Eleventh Grade</option>
    <option value='12'>Twelfth Grade</option>
  <br/>
  </select>
  </div>       
  <div  style={{ textAlign: 'right' }}><h3 style={{display:'inline',marginRight:'1rem'}}>Program Start Date:</h3>
  <select
    style={{
      display:'inline',
      width: '200px',
      height: '30px',
      marginBottom: '1rem' }}
     defaultValue='def'

    value={selectedDate}
    onChange={(e) => {
    
      setGrade('def')
      setCategory('def')
      setDate('def');
        setIsFiltered(true);

        switch(parseInt(e.target.value)){

           case 0:
            {setDate('0');setFiltered(classes.filter(c=>c.Start_Date=='June 21').sort(sortByGrade));break};
            case 1:
            {setDate('1');setFiltered(classes.filter(c=>c.Start_Date=='June 28').sort(sortByGrade));break;}
            case 2:
            {setDate('2');setFiltered(classes.filter(c=>c.Start_Date=='July 6').sort(sortByGrade));break;}
            case 3:
            {setDate('3');setFiltered(classes.filter(c=>c.Start_Date=='July 12').sort(sortByGrade));break;}
            case 4:
            {setDate('4');setFiltered(classes.filter(c=>c.Start_Date=='July 19').sort(sortByGrade));break;}
            case 5:
            {setDate('5');setFiltered(classes.filter(c=>c.Start_Date=='July 26').sort(sortByGrade));break;}
            case 6:
            {setDate('6');setFiltered(classes.filter(c=>c.Start_Date=='August 2').sort(sortByGrade));break;}
            case 7:
            {setDate('7');setFiltered(classes.filter(c=>c.Start_Date=='August 9').sort(sortByGrade));break;}
            case 8:
            {setDate('8');setFiltered(classes.filter(c=>c.Start_Date=='August 16').sort(sortByGrade));break;}
         }
      
      console.log(e.target.value)
    }}
  >
    <option value='def' disabled>
      ---Please select one---
    </option>
    <option value='0'>June 21</option>
    <option value='1'>June 28</option>
    <option value='2'>July 6</option>
    <option value='3'>July 12</option>
    <option value='4'>July 19</option>
    <option value='5'>July 26</option>
    <option value='6'>August 2</option>
    <option value='7'>August 9</option>
    <option value='8'>August 16</option>
    <br/>
</select>
    <br/>
  </div>
  
    <button className='btn btn-dark btn-sm' style={{marginLeft:'1rem'}} onClick={()=> {setCategory('def'); setGrade('def'); setDate('def');setIsFiltered(false);}}>View All Programs</button>
        </div>
      </div>

      <div className='row'>




        {
      !isFiltered&& classes.map((d, i) => <div className='col-sm-12' style={{ borderTop: '1px solid black', paddingTop: '10px', marginBottom: '3rem' }}>
          <div id="textbox">
          <p class="alignleft"><span className='bold-text'><h2 className='bolder'>{d.Program_Name}</h2> Grades: {d.Grades}  | {d.Start_Date}-{d.End_Date}</span> | <span className='regular-text'></span>{d.Tuition} | <span className='bold-text'>{d.New_since_Mar10}</span></p> </div>
          <p class="alignright">{d.Registration_Link&& <button className='btn btn-sm btn-info btn-block'><a href={d.Registration_Link} target='blank' style={{textDecoration:'none'}}><span style={{color:'white'}}>Register Now</span></a></button>}
          </p>
          <p style={{ clear: 'both' }}></p>
          {d.Days_of_the_week}, {d.Start_Time}-{d.End_Time}
          <br />
          <span className='bold-text'>Location:</span> {d.Location}<br/>
          <span className='bold-text'>Instructor:</span> {d.instructor}<br/>
          <span className='bold-text'>Min/Max Students:</span> {d.Min_Students}{d.Max_Students?`/${d.Max_Students}`:''}<br/>
          <span className='bold-text'>Materials fee:</span> {d.Material_Fee||'N/A'}<br/>
          <br/>
          <span className='regular-text'> {d.Program_Description}</span><br/>
          <br />
          <span className='bold-text'>Prerequisities:</span> {d.Prerequisites||'None'}<br/>
          <span className='bold-text'>Contact:</span><a href={`mailto: ${d.Program_Chair_Email}`}> {d.Program_Chair_Email}</a>
          <br/>
         
        </div>)}


        {
      isFiltered&& filtered.map((d, i) => <div className='col-sm-12' style={{ borderTop: '1px solid black', paddingTop: '10px', marginBottom: '3rem' }}>
          <div id="textbox">
          <p class="alignleft"><span className='bold-text'><h2 className='bolder'>{d.Program_Name}</h2> Grades: {d.Grades}  | {d.Start_Date}-{d.End_Date}</span> | <span className='regular-text'></span>{d.Tuition} | <span className='bold-text'>{d.New_since_Mar10}</span></p> </div>
          <p class="alignright">{d.Registration_Link&& <button className='btn btn-sm btn-info btn-block'><a href={d.Registration_Link} target='blank' style={{textDecoration:'none'}}><span style={{color:'white'}}>Register Now</span></a></button>}
          </p>
          <p style={{ clear: 'both' }}></p>
          {d.Days_of_the_week}, {d.Start_Time}-{d.End_Time}
          <br />
          <span className='bold-text'>Location:</span> {d.Location}<br/>
          <span className='bold-text'>Instructor:</span> {d.instructor}<br/>
          <span className='bold-text'>Min/Max Students:</span> {d.Min_Students}{d.Max_Students?`/${d.Max_Students}`:''}<br/>
          <span className='bold-text'>Materials fee:</span> {d.Material_Fee||'N/A'}<br/>
          <br/>
          <span className='regular-text'> {d.Program_Description}</span><br/>
          <br />
          <span className='bold-text'>Prerequisities:</span> {d.Prerequisites||'None'}<br/>
          <span className='bold-text'>Contact:</span><a href={`mailto: ${d.Program_Chair_Email}`}> {d.Program_Chair_Email}</a>
          <br/>
         
    </div>)}
    
      </div>
    <Link to='/'> <button className='btn btn-dark btn-sm p-3 btn-block'> Back to Homepage</button></Link>
    </div>
  );
}



export default ProgramsByCategory
